import identity from "lodash/identity"
import { Fragment, useState } from "react"
import { Field, useForm } from "react-final-form"

import { marketingClient, useQueryClient } from "@trueskin-web/apis"
import { required } from "@trueskin-web/functions"
import { getCountries, getCountry } from "@trueskin-web/locales"
import { useTranslation } from "@trueskin-web/translations"

import useConfirm from "../../../hooks/use-confirm"

import InputControl from "./input-control"

const countries = getCountries()

const supportedCountries = ["DE"]

const Country = ({ disabled, onChange, className }) => {
  const { t } = useTranslation()

  const queryClient = useQueryClient()

  const form = useForm()

  const [ConfirmationDialog, confirmCountryChange, closeConfirmationDialog] =
    useConfirm()

  const [isSubmitting, setIsSubmitting] = useState(false)

  const countryCode = getCountry()

  const {
    data: { instalments = {} },
  } = queryClient.getQueryData("currentOrderSummary")

  const validateChange = async (event) => {
    const {
      target: { value: country },
    } = event

    if (supportedCountries.includes(country)) {
      return null
    }

    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.SWISS_ERROR_2M,
    })

    const isCountryChangeConfirmed = await confirmCountryChange()

    if (isCountryChangeConfirmed) {
      setIsSubmitting(true)

      handleChange(country)

      marketingClient.sendEvent({
        name: marketingClient.EVENT_TYPES_ENUM.SWISS_ERROR_CLICK_ON_BACK,
      })
    } else {
      marketingClient.sendEvent({
        name: marketingClient.EVENT_TYPES_ENUM.SWISS_ERROR_CLICK_ON_CANCEL,
      })
    }
  }

  const handleChange = async (countryCode) => {
    form.change("country", countryCode)

    await onChange(countryCode)

    setIsSubmitting(false)
    closeConfirmationDialog()
  }

  return (
    <Fragment>
      <Field
        data-testid="web-portal-shipping-form-country"
        name="country"
        required
        validate={(value) =>
          required(value, t("Generic.errors.countryRequired"))
        }
        parse={identity}
        defaultValue={countryCode}
        disabled={disabled}
        label={t("Start.Questionnaire.country")}
        placeholder={t("Start.Questionnaire.country")}
        size="xlg"
        className={className}
        render={({
          input: { onChange: onInputChange, ...input },
          ...props
        }) => (
          <InputControl
            as="select"
            onChange={instalments.count === 2 ? validateChange : onInputChange}
            {...input}
            {...props}
          >
            <option value="" hidden disabled>
              {t("Start.Questionnaire.country")}
            </option>
            {countries.map((country) => (
              <option key={country.code} value={country.code}>
                {country.label}
              </option>
            ))}
          </InputControl>
        )}
      />

      <ConfirmationDialog
        data-testid="web-portal-change-package-dialog"
        sx={{
          "&[data-reach-dialog-content]": {
            maxWidth: 480,
          },
        }}
        isLoading={isSubmitting}
        aria-label="Change Country Dialog"
        noMobileFullscreen
        title={t("Start.Shipping.changeCountryDialog.title")}
        description={t("Start.Shipping.changeCountryDialog.description")}
        primaryActionLabel={t("Button.goBack")}
      />
    </Fragment>
  )
}

export default Country
